module.exports = __webpack_public_path__ + "img/otp-phone.a22ac80c.jpg";